module.exports = __webpack_public_path__ + "img/map-verdico.def8c281.svg";